/*@flow*/

const hasOwn = Object.prototype.hasOwnProperty;
export default (o: Object, k: string) => hasOwn.call(o, k);
